import { ReactNode } from "react";
import { Link } from "react-router-dom";
import ROUTES from "@/data/Routes";
import whyToStartMob from "@/assets/video/video_3.mp4";
import whyToStart from "@/assets/video/video_3.mp4";
import faq from "@/assets/video/video_1.mp4";

import yourGenesMob from "@/assets/images/genomTest/your_genes_mob.png";
import discsMob from "@/assets/images/genomTest/discs_mob.png";
import habitsMob from "@/assets/images/genomTest/habits_mob.png";
import blood from "@/assets/images/fullBloodTest/Blood.png";
import epi from "@/assets/images/epiTest/epi.png";

export interface CollapsibleData {
  label: string;
  description: string;
  img_src: string;
  img_mob_src: string;
  img_alt: string;
  items: CollapsibleInner[];
}

interface CollapsibleInner {
  id: number;
  label: string;
  description: string | ReactNode;
}

export const COLLAPSABLE_CONTENT_WHYTOSTART_VALUES: CollapsibleData = {
  label: "Kodėl verta pradėti nuo gyvensenos programos?",
  description:
    "Telomera pagal Jūsų sveikatos duomenis parengs individualizuotą gyvensenos protokolą, padės jo laikytis siekiant išvengti ligų, valdyti jų rizikas bei pasiekti geriausią savijautą.",
  img_src: whyToStart,
  img_mob_src: whyToStartMob,

  img_alt: "why to start",
  items: [
    {
      id: 1,
      label: "Konsultacijų išvados",
      description:
        "Dirbdami kartu - genetikas, gydytoja, medicinos gyvensenos specialistė, farmacininkas - pagal Jūsų sveikatos duomenis pateiks išvadas, kurios leis pasiekti geriausią savijautą.",
    },
    {
      id: 2,
      label: "Epigenetika",
      description:
        "Žinant savo biologinį amžių suprasite, kaip gyvenimo būdas ir aplinka veikia Jūsų ląsteles. Gydytojai paruoš veiksmų planą, kuris leis lėtinti sėnėjimo procesus ir mažinti biologinį amžių.",
    },
    {
      id: 3,
      label: "Genetika",
      description:
        "Genetikos rezultatais galėsite vadovautis visą gyvenimą. Mūsų genetikas išanalizuos Jūsų 15 sveikatos sričių ir pateiks įžvalgas, kurios leis patobulinti savo gyvenimą.",
    },
    {
      id: 4,
      label: "Maisto papildai ir medikamentai",
      description:
        "Atlikus visus Telomera tyrimus žinosite, kurie maisto papildai Jums reikalingi, o kurie ne. Farmacininkas galės rekomenduoti Jums pritaikytus papildus ar medikamentus personalizuotomis dozėmis.",
    },
    {
      id: 5,
      label: "Darbo, poilsio, miego režimas",
      description:
        "Genetika atskleis, kada geriausia eiti miegoti ir kiek valandų miego Jums reikia. Tinkamai subalansuotas režimas leis efektyviau atsigauti, sumažinti streso lygį ir pagerinti bendrą savijautą.",
    },
    {
      id: 6,
      label: "Fizinis aktyvumas",
      description:
        "Nesvarbu ar esate visiškai neaktyvus ar profesionalus sportininkas, mūsų specialistai padės Jums rasti tinkamiausią fizinio aktyvumo planą, intensyvumą bei dažnumą.",
    },
    {
      id: 7,
      label: "Streso valdymas",
      description:
        "Specialistai padės suvokti ir pašalinti įpročius, kurie Jums kelia stresą ir paaiškins, kaip jį valdyti. Gydytojai įvertins ar pradinės rekomendacijos Jums yra veiksmingos. Jei ne - ieškos alternatyvių kelių tikslui pasiekti.",
    },
    {
      id: 8,
      label: "Mityba",
      description:
        "Sužinosite, kurie maisto produktai Jums tinka ir kurių reikia vengti. Taip pat, žinosite, kaip reikia maitintis siekiant individualių tikslų.",
    },
    {
      id: 9,
      label: "Kontrolė",
      description:
        "Telomera paciento vadybinkai užtikrins ir Jums primins, kada ir kokius tyrimus reikia atlikti, norint sekti sveikatos progresą.",
    },
  ],
};

export const COLLAPSABLE_CONTENT_WHOLE_BLOOD_TEST_VALUES = {
  label: "Plataus kraujo ištyrimo žymenys",
  description:
    "Nematote Jums reikalingo kraujo žymens? Informuokite slaugytoją kraujo paėmimo metu ir žymuo bus pridėtas prie kraujo ištyrimo paketo.",
  img_src: blood,
  img_mob_src: blood,
  img_alt: "why to start",
  items: [
    {
      id: 1,
      label: "Mikroelementai ir vitaminai",
      description: `• Varis (CU) • Feritinas (FERRI) • Vitaminas D • Vitaminas B12 • Gliukozė (GLU) • Geležis (FE) • Cinkas (ZN) • Folio rūgštis (FR) • Albuminas (ALB)`,
    },
    {
      id: 2,
      label: "Inkstų funkcija ir elektrolitai",
      description: `• Kreatininas (CREA) • Šlapimo rūgštis (UA) • Glomerulų filtracijos greitis • (GFG) Kalcis (CA) • Jonizuotas kalcis (CA+ +) • Kalis (KA) • Magnis (MG) • Chloras (CL) • Natris (NA) • Fosforas (PHOS) • Šlapalas (UREA)`,
    },
    {
      id: 3,
      label: "Kepenų ir kasos veikla",
      description: `• Asparto aminotransferazė (AST) • Alanino aminotransferazė (ALT) • Gama glutamiltransferazė (GGT) • Tiesioginis bilirubinas (BIL-D) • Netiesioginis bilirubinas (N-BIL) • Bendras bilirubinas (BIL-T) • Pankreatinė amilazė (P-AMYL) • Šarminė fosfatazė (ALP) • Laktatdehidrogenazė (LDH)`,
    },
    {
      id: 4,
      label: "Endokrininė sistema",
      description: `• Tirotropinis hormonas (TTH/TSH) • Antikūnai prieš skydliaukės peroksidazę • Kortizolis • Laisvas trijodtironinas (FT3) • Laisvas tiroksinas (FT4) • Testosteronas (TEST) • Laisvasis testosteronas • Lytinius hormonus sujungiantis globulinas (SHBG) • Laisvas prostatos specifinis antigenas (LPSA) • Parathormonas (PTH) • Glikozilintas hemoglobinas (HBA1C) • Rezistentiškumas insulinui (HOMA IR) • Laisvas androgenų indeksas (LAI)`,
    },
    {
      id: 5,
      label: "Imuninė sistema ir infekcijos",
      description: `• Bendras kraujo tyrimas (BKT) • Lipidograma (DTL, MTL, trigliceridai, Ne DTL) • Homocisteinas • Eritrocitų nusėdimo greitis (ENG) • Apolipoproteinas A (APO A1) • Apolipoproteinas B (APO B) • Apolipoproteino A/B santykis • Transferinas (TRANS) • Reumatoidinis faktorius (RF) • C reaktyvus baltymas (CRB) • Bendras baltymas (TP) • Helicobacter pylori IgG`,
    },
  ],
};

export const COLLAPSABLE_CONTENT_KNOW_YOUR_AGE_VALUES: CollapsibleData = {
  label: "Sužinokite savo tikrąjį amžių",
  description:
    "Epigenetika parodys, kaip gyvenimo būdas ir aplinka paveikė Jūsų organizmo ląsteles. Tyrimas suteiks vertingų įžvalgų, kaip galite sulėtinti senėjimą, stiprinti sveikatą ir užkirsti kelią ligoms",
  img_src: epi,
  img_mob_src: epi,

  img_alt: "why to start",
  items: [
    { id: 1, label: "Biologinis amžius", description: "" },
    // { id: 2, label: "Akių amžius ir elektrolitai", description: "" },
    { id: 2, label: "Klausos amžius", description: "" },
    { id: 3, label: "Atminties amžius ", description: "" },
    { id: 4, label: "Senėjimo greitis", description: "" },
    { id: 5, label: "Uždegiminis rodiklis", description: "" },
    { id: 6, label: "Organizmo atsakas į uždegimą", description: "" },
  ],
};

export const COLLAPSABLE_CONTENT_DISCOVER_YOUR_GENES_VALUES: CollapsibleData = {
  label: "Atraskite ir valdykite ligų riziką",
  description: "",
  img_src: yourGenesMob,
  img_mob_src: yourGenesMob,
  img_alt: "your genes",
  items: [
    {
      id: 1,
      label: "Kraujo ligų rizika",
      description:
        "• Eritrocitų ligos • Leukocitų ligos • Trombocitų ligos • Krešėjimo sutrikimai • Kaulų čiulpų nepakankamumo sindromas • Imuniniais genetiniais sutrikimai • Paveldima kraujo vėžio rizika • MPN / MDS predispozicija • Geležies metabolizmo liga • Retos kraujo ligos • Ribosomopatijos / telomeropatijos • Paveldimi kraujo rodiklių nukrypimia",
    },
    {
      id: 2,
      label: "Metabolinių ligų rizika",
      description:
        "• Aminorūgščių apykaitos sutrikimai • Organinių rūgščių apykaitos defektai • Riebalų rūgščių oksidacijos sutrikimai • Angliavandenių apykaitos sutrikimai • Ureos ciklo sutrikimai • Lizosomų kaupimo ligos (LSDs) • Peroksizomų funkcijos sutrikimai • Mitrochondrijų metabolizmo sutrikimai • Purinų ir pirimidinų apykaitos sutrikimai • Lipidų ir cholesterolio apykaitos sutrikimai • Hormonų ir steroidų sintezės sutrikimai • Vitaminų ir kofaktorių metabolizmo sutrikimai • Metalų (geležies, vario ir kt.) metabolizmo sutrikimai • Poliolių (cukraus alkoholio) apykaitos sutrikimai • Transporterių (SLC genų šeimos) defektai • Glikozilinimo defektai (CDG – congenital disorders of glycosylation) • Neuro-metaboliniai sindromai • Retos pavienės metabolinės ligos",
    },
    {
      id: 3,
      label: "Onkologinių ligų rizika",
      description:
        "• Krūties ir kiaušidžių vėžiai • Gimdos ir endometriumo vėžiai • Kolorektaliniai vėžiai • Skrandžio vėžiai • Kasos vėžiai • Inkstų vėžiai • Skydliaukės vėžiai (MEN sindromai) • Melanoma • Nervų sistemos navikai (pvz., neurofibromatozės) • Leukemijos / limfomos • Vaikystės vėžiai • Paragangliomos / feochromocitomos • Multinavikiniai sindromai (Li-Fraumeni ir kt.) • Germ cell navikai • Hematologinės onkologinės ligos • CNS navikai (atskirai nuo Li-Fraumeni ir Turcot sindromo) • Germinaliniai navikai • Poligeninės rizikos grupės (PRS) • Gerybinių navikų ir hamartominių sindromų predispozicija (pvz., Cowden, TSC) ",
    },
    {
      id: 4,
      label: "Neurodegeneracinių ligų rizika",
      description:
        "• Alzheimerio ligos formos • Parkinsono ligos ir parkinsonizmo sindromai • Fronto-temporalinė demencija (FTD) • Amiotrofinė lateralinė sklerozė (ALS) • Huntingtono liga • Spinocerebrinės ataksijos (SCA) • Friedreich ataksija • Dystonijos ir chorejos • Prioninės ligos • Neuronų ceroidinės lipofuscinozės (CLN/Batten ligos) • Leukodistrofijos • Mitofatiniai (mitochondriniai) neurodegeneraciniai sindromai • Neuroaksoninės distrofijos (NBIA grupė) • Rett sindromas • Kanalopatijos su neurodegeneraciniais simptomais • Lipidų / glikozidų kaupimo ligos su neurologine forma • Spinalinės raumenų atrofijos (SMA ir susijusios) • DNR reparacijos defektų sindromai su neurodegeneracija (pvz., ataksija–telangiektazija) • Kompleksinės / poligeninės neurodegeneracinių ligų rizikos (pvz., APOE, GBA)",
    },
    {
      id: 5,
      label: "Širdies ir kraujagyslių ligų rizika",
      description:
        "• Širdies ritmo sutrikimai (aritmijos) • Kardiomiopatijos • Staigios širdinės mirties sindromai • Aortos ir didžiųjų kraujagyslių ligos • Įgimti širdies struktūros defektai • Širdies vožtuvų ligos (paveldimos formos) • Trombozės ir krešėjimo sutrikimai • Paveldimos dislipidemijos • Monogeninės arterinės hipertenzijos formos • Metabolinės širdies ligos (pvz., Fabry, Danon, Pompe) • Mitochondrinės kardiologinės ligos • Multisisteminiai genetiniai sindromai su širdies fenotipu • Kraujagyslių displazijos ir veninės anomalijos • Limfinės kraujagyslių sistemos defektai (lymphangiopatijos) • Poligeninės / multifaktorinės širdies ligų rizikos (su PRS) ",
    },
  ],
};

export const COLLAPSABLE_CONTENT_IMPROVE_YOUR_HABITS_VALUES = {
  label: "Gerinkite įpročius ir gyvenimo kokybę",
  description: "",
  img_src: habitsMob,
  img_mob_src: habitsMob,
  img_alt: "habits",
  items: [
    {
      id: 1,
      label: "Mityba",
      description:
        "• Jautrumas angliavandeniams • Jautrumas sotiesiems riebalams • Jautrumas nesotiesiems riebalams • Jautrumas baltymams • Jautrumas cukrui • Polinkis į persivalgymą • Užkandžiavimo rizika • Metabolizmo greitis • Riebalų pasiskirstymas • Yo/Yo dietos atsakas • Jautrumas laktozei",
    },
    {
      id: 2,
      label: "Miegas",
      description:
        "• Miego trukmė • Fragmentuotas miegas • Narkolepsijos rizikas • Streso poveikis miegui • Kofeino poveikis miegui",
    },
    {
      id: 3,
      label: "Stresas",
      description:
        "• Stresas ir iššūkiai • Stresas ir atmintis • Gebėjimas valdyti stresą • Streso sukeliami fiziniai simptomai • Stresas ir širdis • Kofeinas ir stresas",
    },
    {
      id: 4,
      label: "Sportas",
      description:
        "• Raumenų jėga • Raumenų ištvermė • O2 pasisavinimas • Aanerobinis slenkstis • Atsistatymo greitis • Raumenų masė • Traumų rizika • Minkštųjų audinių uždegimas • Liesa kūno masė • Jėgos ir svorio santykis • Jautrumas kofeinui • Genetinis kaulų mineralų tankis • Nutukimo rizika • 2 tipo diabeto rizika • Infekcijų rizika",
    },
    {
      id: 5,
      label: "Sveikata",
      description:
        "• Jautrumas kofeinui • Genetinis kaulų mineralų tankis • Nutukimo rizika • 2 tipo diabeto rizika • Infekcijų rizika",
    },
    {
      id: 6,
      label: "Vitaminai ir mikroelementai",
      description:
        "• Vitaminas D • Vitaminas A • Geležis • Magnis • Kalis • Natris • Vitaminas B6 • Vitaminas B12 • Folio rūgštis • Selenas • Kalcis • Omega-3 • BCAA • Cholinas • Glutaminas • Kreatinas • Beta-alaninas • Argininas",
    },
  ],
};

export const COLLAPSABLE_CONTENT_HOME_FAQ_VALUES = {
  items: [
    {
      id: 1,
      label: "Ar galima įsigyti tik CORE ir APEX narystes?",
      description: (
        <>
          Ne, galima įsigyti ne tik CORE ir APEX narystes, bet ir pavienes
          paslaugas. Jei nesate tikri, kuris variantas jums tinkamiausias,
          kviečiame{" "}
          <Link to={ROUTES.CONSULTATION} className="text-black underline">
            užsiregistruoti konsultacijai
          </Link>{" "}
          – jos metu padėsime įsivertinti poreikius ir pasiūlysime tinkamiausią
          sprendimą.
        </>
      ),
    },
    {
      id: 2,
      label:
        "Jaučiuosi sveikas ir reguliariai tikrinuosi sveikatą. Ką papildomai gali suteikti Telomera?",
      description: (
        <>
          Daugelis sveikatos rizikų vystosi tyliai ir ilgą laiką nesukelia
          aiškių simptomų. Įprasti profilaktiniai patikrinimai dažniausiai
          apsiriboja baziniais tyrimais, todėl ne visada padeda anksti pastebėti
          svarbius pokyčius.
          <br />
          Telomera leidžia pažvelgti giliau – įvertinti ne tik kraujo rodiklius,
          bet ir platesnį sveikatos vaizdą: metabolinę būklę, uždegiminius
          procesus, hormonų pusiausvyrą, genetines rizikas ir fizinį pajėgumą.
          <br />
          Svarbiausia, kad gaunate ne tik rezultatus, bet ir aiškų veiksmų
          planą, padedantį prevenciškai stiprinti sveikatą.
        </>
      ),
    },
    {
      id: 3,
      label: "Kaip žinoti kokia kuri narystė man tinka?",
      description: (
        <>
          Pirmas žingsnis pradedant su Telomera – suprasti jūsų situaciją,
          tikslus ir lūkesčius{" "}
          <Link to={ROUTES.CONSULTATION} className="text-black underline">
            nemokamos 15 min. konsultacijos
          </Link>{" "}
          metu įvertinsime, kokia programa ar paslaugos jums būtų tinkamiausios
          pagal jūsų savijautą, sveikatos prioritetus ir tai, ko šiuo metu
          siekiate.
        </>
      ),
    },
    {
      id: 4,
      label: "Nuo kokio amžiaus galima atlikti tyrimus?",
      description:
        "Genetinus ir viso genomo tyrimus galima atlikti nuo jauniausio amžiaus, nes šie rodikliai nesikeičia visą gyvenimą, todėl atlikus tyrimą vaikui - visuomet bus galima remtis genetikos rezultatais. Kiti tyrimai rekomenduojami individualiai aptarus situaciją su pacientu / tėvais.",
    },
    {
      id: 5,
      label: "Kokiose miestuose teikiamos paslaugos?",
      description:
        "Mėginius genetikai ir laboratoriniams tyrimams galima priduoti Vilniuje, Kaune, Šiauliuose, Panevėžyje bei Mažeikiuose, taip pat, esant poreikiui, genetinio tyrimo surinkimui rinkinį į namus galime pristatyti į bet kurį miestą ar šalį. Gydytojo konsultacijos gyvai vyksta Vilniuje, bet visuomet galima susitarti konsultaciją nuotoliniu būdu. Jeigu kyla poreikis tyrimus atlikti kituose miestuose - susisiekite su mumis ir aptarsime galimybes.",
    },
    {
      id: 6,
      label: "Ar galima įsigyti dovanų kuponą?",
      description:
        "Dovanų kuponą galima įsigyti visoms paslaugoms, daliai paslaugų ar pinigų sumai. Norint įsigyti kuponą, susisiekite su mumis info@telomera.lt arba +37067909369. Taip pat, pirkimą galite atikti internetu, naviguojant į dovanų kuponai puslapį.",
    },
  ],
};

export const COLLAPSABLE_CONTENT_GENOM_TEST_FAQ_VALUES: CollapsibleData = {
  label: "Dažniausiai užduodami klausimai",
  description:
    "Telomera visada pasiruošusi atsakyti į jūsų klausimus. Jei nerandate atsakymų žemiau pateiktoje lentelėje, susisiekite su mumis – mielai padėsime!",
  img_src: whyToStart,
  img_mob_src: whyToStartMob,
  img_alt: "why to start",
  items: [
    {
      id: 1,
      label: "Kiek laiko trunka viso genomo analizė?",
      description:
        "DNR analizė trunka nuo 4 iki 6 savaičių. Tyrimas atliekamas surinkus Jūsų kraujo mėginį. Atvykti į kliniką galite Vilniuje, Kaune ir Šiauliuose.",
    },
    {
      id: 2,
      label: "Kokie yra viso genomo tyrimo privalumai?",
      description:
        "Ankstyvas ligų nustatymas ir prevencija - aptinkame genetines mutacijas, kurios gali padidinti tam tikrų ligų (pvz., vėžio, širdies ir kraujagyslių ligų, Alzheimerio) riziką. Tai leidžia imtis veiksmų dar iki ligos atsiradimo.</br>Paveldimumo rizikos ir šeimos sveikata - jei planuojate šeimą, genomo sekvenavimas padeda nustatyti paveldimų ligų riziką, kuri gali būti perduodama vaikams. Asmeninis senėjimo prevencijos protokolas - genetinė informacija leidžia gydytojams pritaikyti gydymą pagal jūsų genų specifiką, todėl gydymas tampa veiksmingesnis ir saugesnis. Gyvenimo būdo tobulinimas - gauti rezultatai padeda geriau suprasti, kaip jūsų kūnas reaguoja į tam tikrą mitybą, fizinį aktyvumą, miego įpročius ar net papildų vartojimą.",
    },
    {
      id: 3,
      label: "Ar tyrimo rezultatai aktualūs po kelerių metų?",
      description:
        "Žmogaus genetika nekinta per visą gyvenimą, todėl tyrimo rezultatais galima vadovautis visada. Pateikiamos išvados gali būti adaptuojamos ateityje, atsižvelgiant į naujus genetikos mokslo atradimus.",
    },
    {
      id: 4,
      label: "Nuo kokio amžiaus galima atlikti DNR tyrimą?",
      description:
        "Viso genomo sekoskaitos tyrimas neturi amžiaus ribos. Genetiniai rodikliai nesikeičia visą gyvenimą, todėl atlikus tyrimą vaikui - visuomet bus galima remtis genetikos rezultatais.",
    },
    {
      id: 5,
      label: "Kaip saugomi genomo tyrimo rezultatai?",
      description:
        "Visi tyrimų rezultatai ir klientų duomenys yra užšifruoti mūsų serveriuose. Mes laikomės ES reglamento 2016/679 ir imamės priemonių nuo bet kokio informacijos nutekėjimo. Trečiosios šalys, įskaitant bet kokius vyriausybės pareigūnus, negali pasiekti mūsų serverio duomenų.",
    },
    {
      id: 6,
      label: "Kiek tikslūs jūsų viso genomo tyrimai?",
      description:
        "Genomo sekoskaita su Novaseq 6000 naudojant Illumina protokolą leidžia ištirti genetinius duomenis didesniu nei 99,9%tikslumu.",
    },
    {
      id: 7,
      label: "Kokiuose miestuose teikiama paslauga?",
      description:
        "Mėginius genetikai / epigenetikai / laboratoriniams tyrimams galima priduoti Vilniuje, Kaune, Šiauliuose, Panevėžyje bei Mažeikiuose, taip pat, esant poreikiui, genetinio tyrimo surinkimui rinkinį į namus galime pristatyti į bet kurį miestą / šalį. Gydytojo konsultacijos gyvai vyksta Vilniuje, bet visuomet galima susitarti konsultaciją nuotoliniu būdu. Jeigu kyla poreikis tyrimus atlikti kituose miestuose - susisiekite su mumis ir aptarsime galimybes.",
    },
    {
      id: 8,
      label: "Kiek laiko saugomi genomo rezultatai?",
      description:
        "Pacientų genomo duomenys yra saugomi visą gyvenimą. Tai leidžia užtikrinti metinę rezultatų peržiūra, atsižvelgiant į naujus genetikos mokslo atradimus.",
    },
  ],
};

export const COLLAPSABLE_CONTENT_COMPREHENSIVE_GENOM_TEST_FAQ_VALUES: CollapsibleData =
  {
    label: "Dažniausiai užduodami klausimai",
    description:
      "Telomera visada pasiruošusi atsakyti į jūsų klausimus. Jei nerandate atsakymų žemiau pateiktoje lentelėje, susisiekite su mumis – mielai padėsime!",
    img_src: whyToStart,
    img_mob_src: whyToStartMob,
    img_alt: "why to start",
    items: [
      {
        id: 1,
        label: "Kodėl verta atlikti genetinį tyrimą?",
        description:
          "Kiekvieno žmogaus organizmas yra unikalus, o genetinis  tyrimas leidžia suprasti, kaip jūsų kūnas įsisavina maistines  medžiagas, reaguoja į fizinį krūvį, koks yra jūsų polinkis į tam  tikras ligas ir kaip galite optimizuoti savo sveikatą. Tai  vienkartinis tyrimas, suteikiantis visą gyvenimą naudingas  įžvalgas apie jūsų organizmą.",
      },
      {
        id: 2,
        label: "Kuo genetinis tyrimas skiriasi nuo kraujo tyrimų?",
        description:
          "Kraujo tyrimai rodo dabartinę sveikatos būklę, todėl juos reikia atlikti periodiškai, o genetinis tyrimas atskleidžia jūsų  įgimtus organizmo polinkius, kuriuos galite naudoti  formuodami ilgalaikį sveikatos planą. Tai tarsi sveikatos  „instrukcija“, kurią turėtumėte visą gyvenimą.",
      },
      {
        id: 3,
        label: "Ar galima keisti savo genetinius polinkius?",
        description:
          "Nors genetika nekinta, jos raiškai didelę įtaką daro mityba,  gyvenimo būdas ir aplinka. Šio tyrimo rezultatai leidžia  pritaikyti individualius sprendimus, kad sumažintumėte  neigiamų genetinių veiksnių poveikį ir optimizuotumėte savo  sveikatą.",
      },
      {
        id: 4,
        label: "Kaip atliekamas tyrimas?",
        description:
          "Viskas labai paprasta – jums tereikia priduoti seilių mėginį mūsų klinikose Vilniuje, Kaune ar Šiauliuose. Po kelių  savaičių gausite išsamius rezultatus ir mūsų specialistų  įžvalgas, kaip pritaikyti informaciją savo kasdienybėje.",
      },
      {
        id: 5,
        label: "Kokios naudos galite tikėtis?",
        description: `• Sužinosite, kokios maistinės medžiagos jums reikalingos labiausiai.
                    • Išsiaiškinsite, koks sporto režimas tinkamiausias jūsų kūnui.
                    • Gausite įžvalgų apie miego kokybę, streso valdymą, polinkį į uždegimus.
                    • Turėsite aiškų ilgalaikį veiksmų planą gerai savijautai palaikyti.`,
      },
      {
        id: 6,
        label: "Kas vyksta po tyrimo?",
        description:
          "Kai gausite savo genetinio tyrimo rezultatus, mūsų  specialistai padės jums juos suprasti ir paaiškins, kaip genetika gali turėti įtakos jūsų sveikatai. Jei norėsite gilintis  toliau, galėsite pasirinkti individualias konsultacijas, kuriose  sudarysime personalizuotą mitybos, papildų, fizinio aktyvumo ir ligų prevencijos planą, pritaikytą būtent jūsų  organizmo poreikiams.",
      },
    ],
  };

export const COLLAPSABLE_CONTENT_EPIGEN_AGE_TEST_FAQ_VALUES_2: CollapsibleData =
  {
    label: "Dažniausiai užduodami klausimai",
    description:
      "Telomera visada pasiruošusi atsakyti į jūsų klausimus. Jei nerandate atsakymų žemiau pateiktoje lentelėje, susisiekite su mumis – mielai padėsime!",
    img_src: whyToStart,
    img_mob_src: whyToStartMob,
    img_alt: "why to start",
    items: [
      {
        id: 1,
        label: "Kaip atliekamas epigenetinis tyrimas?",
        description:
          "Epigenetinis tyrimas atliekamas Telomera klinikose, paimant seilių mėginį. Procedūra yra paprasta, neskausminga ir  užtrunka vos kelias minutes.",
      },
      {
        id: 2,
        label: "Kiek laiko užtrunka gauti rezultatus?",
        description:
          "Rezultatai paruošiami per 4–6 savaites. Kai jie bus gauti, mūsų specialistai paaiškins jų reikšmę ir pateiks aiškias  rekomendacijas dėl sveikatos gerinimo.",
      },
      {
        id: 3,
        label: "Ką sužinosiu iš epigenetinio tyrimo?",
        description:
          "Nors genetika nekinta, jos raiškai didelę įtaką daro mityba, gyvenimo būdas ir aplinka. Šio tyrimo rezultatai leidžia pritaikyti individualius sprendimus, kad  sumažintumėte neigiamų genetinių veiksnių poveikį ir optimizuotumėte savo  sveikatą.",
      },
      {
        id: 4,
        label: "Kuo epigenetinis tyrimas skiriasi nuo genetinio?",
        description:
          "Genetinis tyrimas parodo jūsų įgimtus polinkius, o epigenetinis atskleidžia, kaip gyvenimo būdas paveikė jūsų  genų raišką. Tai leidžia suprasti, kokie veiksniai teigiamai  arba neigiamai veikia jūsų sveikatą ir kokius pokyčius galite  įgyvendinti, kad pagerintumėte organizmo būklę.",
      },
      {
        id: 5,
        label: "Kada nerekomenduojama atlikti epigenetinio tyrimo?",
        description: `• Intensyvios fizinės veiklos (sunkios treniruotės ar varžybos)
                    • Didelio streso periodo (miego trūkumas, emocinis išsekimas)
                    • Ligos ar infekcijos (stiprių uždegiminių procesų metu)
                    • Didelių mitybos pokyčių (pvz., po ilgo badavimo ar ekstremalių dietų)
                    Epigenetika atspindi ilgalaikius sveikatos pokyčius, todėl 
                    tyrimą geriausia atlikti stabilioje organizmo būsenoje, kai nėra 
                    trumpalaikių veiksnių, galinčių iškreipti rezultatus.`,
      },
      {
        id: 6,
        label: " Ką daryti gavus rezultatus?",
        description:
          " Jūsų tyrimo rezultatai suteiks aiškų vaizdą apie jūsų organizmo būklę ir epigenetinius procesus. Jei norėsite gauti detalias, individualizuotas rekomendacijas, mūsų specialistai gali parengti išsamų sveikatos planą per papildomas konsultacijas, įvertindami jūsų gyvenimo būdą, mitybą, stresą ir kitus veiksnius.",
      },
    ],
  };

export const COLLAPSABLE_CONTENT_GENOM_TEST_FAQ_VALUES_2: CollapsibleData = {
  label: "Dažniausiai užduodami klausimai",
  description:
    "Telomera visada pasiruošusi atsakyti į jūsų klausimus. Jei nerandate atsakymų žemiau pateiktoje lentelėje, susisiekite su mumis – mielai padėsime!",
  img_src: faq,
  img_mob_src: faq,
  img_alt: "why to start",
  items: [
    {
      id: 1,
      label: "Apie tyrimą",
      description:
        "Tyrimo metu 100 dalyvių bus stebimi, siekiant įvertinti, kaip maisto papildų protokolas veikia kūno biologinį amžių – rodiklį, kuris atspindi tikrąjį kūno senėjimo tempą. Taip pat, bus atliekami išsamūs genetiniai ir kraujo tyrimai.Tyrima tipas bus prospektyvusis, stebėsenos.Tiriamieji bus suskirstyti į dvi grupes: tiriamųjų grupė ir palyginamoji grupė. Pirmajai tiriamųjų grupei bus skiriami/išduodami maisto papildų rinkiniai, imami kraujo ir seilių mėginiai tyrimams. Antrajai, palyginamajai tiriamųjų grupei bus tik imami kraujo ir seilių mėginiai tyrimams.",
    },
    {
      id: 2,
      label: "Koks tyrimo tikslas ir trukmė?",
      description:
        "Ankstyvas ligų nustatymas ir prevencija - aptinkame genetines mutacijas, kurios gali padidinti tam tikrų ligų (pvz., vėžio, širdies ir kraujagyslių ligų, Alzheimerio) riziką. Tai leidžia imtis veiksmų dar iki ligos atsiradimo.</br>Paveldimumo rizikos ir šeimos sveikata - jei planuojate šeimą, genomo sekvenavimas padeda nustatyti paveldimų ligų riziką, kuri gali būti perduodama vaikams. Asmeninis senėjimo prevencijos protokolas - genetinė informacija leidžia gydytojams pritaikyti gydymą pagal jūsų genų specifiką, todėl gydymas tampa veiksmingesnis ir saugesnis. Gyvenimo būdo tobulinimas - gauti rezultatai padeda geriau suprasti, kaip jūsų kūnas reaguoja į tam tikrą mitybą, fizinį aktyvumą, miego įpročius ar net papildų vartojimą.",
    },
    {
      id: 3,
      label: "Kokia tyrimo hipotezė?",
      description:
        "Žmogaus genetika nekinta per visą gyvenimą, todėl tyrimo rezultatais galima vadovautis visada. Pateikiamos išvados gali būti adaptuojamos ateityje, atsižvelgiant į naujus genetikos mokslo atradimus.",
    },
    {
      id: 4,
      label: "Kokie tyrimo uždaviniai?",
      description:
        "Viso genomo sekoskaitos tyrimas neturi amžiaus ribos. Genetiniai rodikliai nesikeičia visą gyvenimą, todėl atlikus tyrimą vaikui - visuomet bus galima remtis genetikos rezultatais.",
    },
    {
      id: 5,
      label: "Koks tyrimo pagrįstumas?",
      description:
        "Visi tyrimų rezultatai ir klientų duomenys yra užšifruoti mūsų serveriuose. Mes laikomės ES reglamento 2016/679 ir imamės priemonių nuo bet kokio informacijos nutekėjimo. Trečiosios šalys, įskaitant bet kokius vyriausybės pareigūnus, negali pasiekti mūsų serverio duomenų.",
    },
    {
      id: 6,
      label: "Kokie įtraukimo kriterijai į tyrimą?",
      description:
        "Genomo sekoskaita su Novaseq 6000 naudojant Illumina protokolą leidžia ištirti genetinius duomenis didesniu nei 99,9%tikslumu.",
    },
    {
      id: 7,
      label: "Kokia maisto papildų kokybinė sudėtis?",
      description:
        "Mėginius genetikai / epigenetikai / laboratoriniams tyrimams galima priduoti Vilniuje, Kaune, Šiauliuose, Panevėžyje bei Mažeikiuose, taip pat, esant poreikiui, genetinio tyrimo surinkimui rinkinį į namus galime pristatyti į bet kurį miestą / šalį. Gydytojo konsultacijos gyvai vyksta Vilniuje, bet visuomet galima susitarti konsultaciją nuotoliniu būdu. Jeigu kyla poreikis tyrimus atlikti kituose miestuose - susisiekite su mumis ir aptarsime galimybes.",
    },
  ],
};

export const COLLAPSABLE_CONTENT_LONGEVITY_FAQ_VALUES: CollapsibleData = {
  label: "Kyla klausimų? Padėsime į juos atsakyti",
  description: "",
  img_src: "",
  img_mob_src: "",
  img_alt: "",
  items: [
    {
      id: 1,
      label: "Kas yra ilgaamžiškumo programa?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 2,
      label: "Kam skirta ši programa?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 3,
      label: "Kiek laiko trunka Ilgaamžiškumo programa?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 4,
      label: "Kokius tyrimus atliksite?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 5,
      label: "Su kokiais specialistais susitiksiu programos metu?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 6,
      label: "Ką gausiu po tyrimų ir konsultacijų?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 7,
      label: "Ar programa padeda valdyti lėtines ligas?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 8,
      label: "Kaip bus stebimas mano progresas?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 9,
      label: "Kiek laiko trunka programa?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
    {
      id: 10,
      label: "Ar galiu dalyvauti programoje nuotoliniu būdu?",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
    },
  ],
};

export const COLLAPSABLE_CONTENT_CONTROL_LONGEVITY_FAQ_VALUES = {
  label: "Kontroliuokite senėjimo ir illgaamžiškumo procesus",
  description: "",
  img_src: discsMob,
  img_mob_src: discsMob,
  img_alt: "why to start",
  items: [
    {
      id: 1,
      label: "Oda",
      description:
        "• Jautrumas saulei • Odos senėjimas • Beta Karoteno pasisavinimas • Gliutenas ir oda • Kolageno pasisavinimas • Odos glikacija • Raukšlių atsiradimas • Odos jautrumas",
    },
    {
      id: 2,
      label: "Širdis",
      description:
        "• Nereguliarus širdies susitraukimų dažnis • Aukštas kraujo spaudimas • Druska ir aukštas kraujo spaudimas • Gliutenas ir oda • Cholesterolio MTL/DTL disbalansas • Rizika širdies ir kraujagyslių sistemos ligoms",
    },
    {
      id: 3,
      label: "Žarnynas",
      description:
        "• Gliuteno netoleravimo rizika • Žarnyno dirglumo rizika • Rizika dantenų ligoms • Stresas ir žarnynas • Kofeinas ir žarnynas",
    },
    {
      id: 4,
      label: "Senėjimas",
      description:
        "• Fizinių gebėjimas mažėjimas • Kognityvinių funkcijų mažėjimas • Testosterono mažėjimas • Kaulų stiprumo mažėjimas • Nugaros skausmas ir senėjimas • Odos glikacija • Raukšlių atsiradimas • Odos jautrumas",
    },
    {
      id: 5,
      label: "Regėjimas",
      description:
        "• Regėjimo degeneracija su amžiumi • Kataraktos rizika • Atvirojo kampo glaukoma • Beta Karoteno pasisavinimas • Akys ir B grupės vitaminų trūkumas",
    },
    {
      id: 6,
      label: "Imunitetas",
      description:
        "• Imuninė funkcija • Vitaminas D ir imunitetas • B grupės vitaminai ir imunitetas • Selenas ir imunitetas • PTPN22 ir imunitetas • Vitaminas E ir imunitetas • Vitaminas C ir imunitetas • Atsakas į infekcijas",
    },
    {
      id: 7,
      label: "Kognityviniai gabumai",
      description:
        "• Koncentracijos periodas • Darboholizmo rizika • Kofeino poveikis koncentracijai • Atmintis • Naktinis produktyvumas",
    },
    {
      id: 8,
      label: "Raumenynas ir traumų rizika",
      description:
        "• Apatinės nugaros dalies skausmo rizika • Kaulų ir sanarių stiprumas • Achilo tendinopatija • Kelėnų stiprumas • Tinkamas reabilitacijos tipas • Miostatinų pajėgumas • Treniruočių sukeltas raumenų skausmas • Su stresu susijęs raumenų skausmas • Kofermento Q10 trūkumas • Natūralus testosterono lygis",
    },
  ],
};

export const COLLAPSABLE_CONTENT_SUPPLEMENTES_FAQ_VALUES: CollapsibleData = {
  label: "Dažniausiai užduodami klausimai",
  description:
    "Telomera visada pasiruošusi atsakyti į jūsų klausimus. Jei nerandate atsakymų žemiau pateiktoje lentelėje, susisiekite su mumis – mielai padėsime!",
  img_src: whyToStart,
  img_mob_src: whyToStartMob,
  img_alt: "why to start",
  items: [
    {
      id: 1,
      label: "Ar galiu pateikti savo tyrimų rezultatus, jei juos jau turiu?",
      description:
        "Taip! Jūs arba jūsų gydytojas galite įkelti savo esamus kraujo, genetinius ar kitus tyrimų rezultatus į platformą, o mūsų specialistai įvertins juos sudarydami jūsų papildų planą.",
    },
    {
      id: 2,
      label: "Kuo eternaLIFE papildai skiriasi nuo įprastų maisto papildų?",
      description:
        "Skirtingai nei standartiniai papildai, kurie yra vienodi visiems, eternaLIFE sudaro personalizuotus sprendimus pagal jūsų sveikatos būklę, tyrimų rezultatus ir organizmo poreikius.",
    },
    {
      id: 3,
      label: "Kas atsitinka, jei mano sveikatos būklė pasikeičia?",
      description:
        "Jei atliekate naujus tyrimus ar keičiasi jūsų sveikatos būklė, platformoje galima atnaujinti duomenis, o specialistai pritaikys jūsų papildų planą pagal naujausią informaciją.",
    },
    {
      id: 4,
      label: "Kaip nustatoma, kokius papildus man reikia vartoti?",
      description:
        "Jūsų papildų planą sudaro medicinos specialistai, remdamiesi jūsų genetiniais, kraujo tyrimų ir kitais sveikatos duomenimis. Taip užtikrinama, kad papildai atitiks jūsų individualius poreikius.",
    },
    {
      id: 5,
      label: "Ar galiu keisti savo papildų prenumeratą?",
      description:
        "Taip, jūs bet kada galite keisti, koreguoti ar atšaukti savo prenumeratą platformoje. Be to, specialistai reguliariai vertina jūsų sveikatos rodiklius ir, jei reikia, atnaujina papildų sudėtį.",
    },
    {
      id: 6,
      label: "Kaip ir kada gausiu savo papildus?",
      description:
        "Papildai pristatomi kas mėnesį tiesiai į jūsų nurodytą adresą. Kiekvienas užsakymas pateikiamas aiškiai suženklintose pakuotėse, kad būtų lengva suprasti dozavimą ir vartojimo laiką.",
    },
  ],
};

export const COLLAPSABLE_CONTENT_CONTACTS_FAQ_VALUES: CollapsibleData = {
  label: "Dažniausiai užduodami klausimai",
  description:
    "Turite klausimų? Susisiekite su mumis – mielai atsakysime ir paaiškinsime viską, kas jums svarbu.",
  img_src: whyToStart,
  img_mob_src: whyToStartMob,
  img_alt: "",
  items: [
    {
      id: 1,
      label: "Ar galima atlikti tik pilną ištyrimo paketą?",
      description:
        "Pilnas ištyrimo paketas rekomenduojamas, bet nėra būtinas. Galima atlikti paslaugas atskirai, pagal jūsų poreikį, tačiau yra keletas išlygų. Norint atlikti pirmąjį kartą epigenetinį tyrimą, pirmiausia būtina atlikti genetinį tyrimą, vėliau galima kartoti tik epigenetiką. Jeigu kraujo tyrimai atlikti neseniai - galime remtis jų rezultatais arba peržiūrėti ir rekomenduoti, ką patartumėme atlikti papildomai ar pakartotinai.",
    },
    {
      id: 2,
      label: "Kaip žinoti ar pilnas ištyrimo paketas man tinka?",
      description:
        "Pirmas žingsnis norint pradėti kelionę su Telomera - lūkesčių ir paciento situacijos suvokimas. Pagal tai, kokia jūsų esama būklė bei norai, komanda patars ar šis paketas ir tyrimai yra jums tinkamiausias.",
    },
    {
      id: 3,
      label: "Nuo kokio amžiaus galima atlikti tyrimus?",
      description:
        "Genetinį tyrimą galima atlikti nuo jauniausio amžiaus, nes šie rodikliai nesikeičia visą gyvenimą, todėl atlikus tyrimą vaikui - visuomet bus galima remtis genetikos rezultatais. Kiti tyrimai rekomenduojami individualiai aptarus situaciją su pacientu / tėvais.",
    },
    {
      id: 4,
      label: "Ar galima įsigyti dovanų kuponą?",
      description:
        "Dovanų kuponą galima įsigyti visoms paslaugoms, daliai paslaugų ar pinigų sumai. Norint įsigyti kuponą, susisiekite su mumis info@telomera.lt arba + 37063988229. Dovanų kuponą galima įsigyti elektroniniu PDF formatu.",
    },
    {
      id: 5,
      label: "Kokiuose miestuose teikiamos paslaugos?",
      description:
        "Mėginius genetikai / epigenetikai / laboratoriniams tyrimams galima priduoti Vilniuje, Kaune, Šiauliuose, Panevėžyje bei Mažeikiuose, taip pat, esant  poreikiui, genetinio tyrimo surinkimui rinkinį į namus galime pristatyti į bet kurį miestą / šalį. Gydytojo konsultacijos gyvai vyksta Vilniuje, bet visuomet galima susitarti konsultaciją nuotoliniu būdu. Jeigu kyla poreikis tyrimus atlikti kituose miestuose - susisiekite su mumis ir aptarsime galimybes.",
    },
    {
      id: 6,
      label: "Kaip žinoti, kada tyrimus kartoti ar atlikti papildomai?",
      description:
        "Telomera pacientų vadybininkė informuoja pacientus apie kiekvieną žingsnį, padeda nepasimesti tarp konsultacijų išvadų bei susisiekia esant poreikiui kartoti / atlikti papildomus tyrimus.",
    },
  ],
};
